import React, { Component } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import cx from 'classnames';
import Modal from 'react-bootstrap/lib/Modal';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';

import messages from '../../../../locale/messages';
import { closeSmtpSetupModal } from '../../../../actions/siteadmin/modalActions';
import s from './SMTPModal.css';
import SMTPForm from '../SMTPForm/SMTPForm';

class SMTPModal extends Component {
  static defaultProps = {
    smtpSetupModalType: 'add'
  };

  constructor(props) {
    super(props);
  }

  render() {
    const { closeSmtpSetupModal, smtpSetupModal, smtpSetupModalType, paginationData, currentPage } = this.props;

    return (
      <div>
        <Modal show={smtpSetupModal} onHide={closeSmtpSetupModal} className={'adminModal'}>
          <Modal.Header closeButton>
            <Modal.Title>{smtpSetupModalType == 'add' ? <FormattedMessage {...messages.addLabel} /> : <FormattedMessage {...messages.editLabel} />} <FormattedMessage {...messages.smtpSetupLabel} /></Modal.Title>
          </Modal.Header>
          <Modal.Body bsClass={s.logInModalBody}>
            <div className={cx(s.modalRoot, s.modalBorderBottom)}>
              <SMTPForm paginationData={paginationData} currentPage={currentPage} />
            </div>
          </Modal.Body>
        </Modal>
      </div>
    )
  }
}

const mapState = (state) => ({
  smtpSetupModal: state?.adminModalStatus?.smtpSetupModal,
  smtpSetupModalType: state?.adminModalStatus?.smtpSetupModalType
});

const mapDispatch = {
  closeSmtpSetupModal
};

export default injectIntl(withStyles(s)(connect(mapState, mapDispatch)(SMTPModal)));